export const getLinks = (msg, post_school_label) => {
	const reg_link = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|#|!|%|\:|-)+)/g
    const reg_post = /#(\d{5,6})/g
	msg = msg.replace(reg_post, '<span> <a href="javascript:void(0);" onclick="nav2Post(\'$1\', \'' + post_school_label + '\')">#$1</a> </span>').replace(reg_link, '<a href="$1$2" target="_blank">$1$2</a>')
    return msg
}